<template>
    <div class="grid" ref="topElement">
        <div class="col-12">
            <h1>Maintenance In Progress</h1>
            <div v-if="isRetrying">
                <h3>We'll be back soon!</h3>
                <p>We will automatically redirect you to the page you were trying to access when we're back online.</p>
                <p>Attempting Redirect to: {{ redirectPath }} in {{ secondsRemaining }}s.</p>
            </div>
            <div v-else>
                <h3>Service Unavailable</h3>
                <p>We are currently performing maintenance on our services. Please check back later.</p>
                <p><strong>Reconnecting to:</strong> {{ redirectPath }}</p>
                <Button @click="retryNow">Retry Now</Button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, inject } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const router = useRouter();
const store = useStore();
const showToast = inject('showToast');
let retryInterval = null;

const retryIntervalSeconds = 10;
const maxRetries = 12;

const retryCount = ref(0);
const secondsRemaining = ref(retryIntervalSeconds);
const progressValue = ref(0);
const isRetrying = ref(true);
const redirectPath = store.getters['auth/redirectPath'] || '/';

const attemptReRoute = () => {
    if (redirectPath) {
        return router.push(redirectPath);
    }
};

const updateCountdown = () => {
    if (retryCount.value >= maxRetries) {
        isRetrying.value = false;
        clearInterval(retryInterval);
        return;
    }

    if (secondsRemaining.value > 0) {
        secondsRemaining.value -= 1;
        progressValue.value = ((retryIntervalSeconds - secondsRemaining.value) / retryIntervalSeconds) * 100;
    } else {
        secondsRemaining.value = retryIntervalSeconds;
        progressValue.value = 0;
        retryCount.value += 1;
        attemptReRoute();
    }
};

const retryNow = async () => {
    await attemptReRoute()
        .then((result) => {
            if (result) {
                console.log('result', result);
                showToast({
                    severity: 'error',
                    summary: 'Error',
                    detail: `Sorry, we are still performing maintenance on our services. Please check back later.`,
                    life: 5000
                });
            }
        })
        .catch((error) => {
            console.error('Redirect error:', error);
            showToast({
                severity: 'error',
                summary: 'Error',
                detail: `Failed to redirect to ${redirectPath}`,
                life: 5000
            });
        });
};

onMounted(() => {
    retryInterval = setInterval(updateCountdown, 1000);
});

onUnmounted(() => {
    if (retryInterval) {
        clearInterval(retryInterval);
    }
});
</script>
<style scoped></style>
